import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { AppService, CoreProxyService, CoreTypes, FormValidatorService } from 'common-cloudstudio';
import { GearAppService, GearProxyService } from 'common-gear';
import { Subscription } from 'rxjs';
import { PlanServiceService } from './plan-service.service';


@Component({
  selector: 'app-plans',
  templateUrl: './plans.component.html',
  styleUrls: ['./plans.component.scss']
})
export class PlansComponent implements OnInit, OnDestroy {
  @ViewChild('confirmRemove') private _confirmRemove: any;
  @ViewChild('modalCloneView') private _modalCloneView: any;

  _caption: string = "";
  _errorBackEnd: string = "";
  _errorMessage: string;
  _masterDataEntityContent: CoreTypes.MasterEntityDataContent;
  _graphicalView: CoreTypes.GraphicalView = new CoreTypes.GraphicalView();
  _facilityId: number = 0;
  _removeId: number;
  _facilityDescription: string = "";
  _graphicalViewId: number = 0;
  _description: string;
  _newGraphicalViewId: number = 0;
  _planElements: CoreTypes.GraphicalViewPlanElement[] = [];
  _pageStatus = 0;
  subscriptions: Subscription[] = [];

  constructor(
    public _appService: AppService,
    private _gearProxyService: GearProxyService,
    public _gearAppService: GearAppService,
    public _appProxyService: CoreProxyService,
    public formValidatorService: FormValidatorService,
    public coreProxyService: CoreProxyService,
    public planService: PlanServiceService,
  ) {}

  ngOnInit() {
    this.getData();
    this._facilityId = this._appService.getFacilityID();
    this.subscriptions.push(this._gearAppService.onChangeFacilityID.subscribe(facilityId => {
      if (this._facilityId == facilityId) { return; }
      this._facilityId = this._appService.getFacilityID();
    }));

    this.subscriptions.push(this._appService.onFacilitySet.subscribe(() => {
      if (this._facilityId && this._facilityId !== this._appService.getFacilityID()) { this.getData(); }
      this.setFacilityDescription();
    }));

    this.setFacilityDescription();
  }

  ngOnDestroy() {
    this.subscriptions.forEach(s => s.unsubscribe());
  }

  getData() {
    this._masterDataEntityContent = null;
    this._pageStatus = 0;

    this._appProxyService.MasterEntityService.GetMasterEntityContent(
      this._appService.getAccessToken(),
      this._appService.getFacilityID(),
      CoreTypes.CoreMasterEntityType.GraphicalViewPlans,
      success => {
        this._masterDataEntityContent = success;
        this._pageStatus = 1;
        this.setFacilityDescription();
      },
      err => {
        this._pageStatus = 2;
        this._appService.showException(err);
      }
    );
  }

  confirmOnRemove(id) {
    this._removeId = id;
    this._confirmRemove.open();
  }

  remove() {
    this._appProxyService.GraphicalViewService.DeleteGraphicalView(
      this._appService.getAccessToken(),
      this._removeId,
      () => {
        this.getData();
        this.planService._graphicalViewFullList.value.length = 0;
        this.planService._graphicalViewStatus = 0;
        this._confirmRemove.close();
      }, (err) => {
        this._errorMessage = err.Message;
      }
    );
  }

  setFacilityDescription() {
    if(this._facilityDescription && this._appService.getFacilityDescription() === this._facilityDescription) { return; }

    if (this._appService.getFacilityDescription()) {
      this._facilityDescription = ' - ' + this._appService.getFacilityDescription();
    }
  }

  cloneView(graphicalViewId) {
    this._graphicalViewId = graphicalViewId;
    this._modalCloneView.open();
  }

  saveGraphicalView(formElement) {
    if( formElement.form.invalid) {
      const getErrorMessage = this.formValidatorService.getValidationErrors(formElement);
      this._errorMessage = getErrorMessage;
      return;
    }
    if(this._graphicalViewId != 0) {
      this._pageStatus = 0;
      let GraphicalViewPlanElements : CoreTypes.GraphicalViewPlanElement[] = []
      this.coreProxyService.GraphicalViewService.GetGraphicalView(
        this._appService.getAccessToken(),
        this._graphicalViewId,
        async (data: CoreTypes.GraphicalView) => {
          this._graphicalView = data;
          if(this._graphicalView){
            this._graphicalView.Description = this._description;
            this._graphicalView.GraphicalViewID = 0;
            this._graphicalView.PlanElements.forEach(element =>{ element.GraphicalViewPlanElementID = 0; })
            this.planService.cloneSelectedElement(this._graphicalView.PlanElements).subscribe(res =>{
              if(!res){ return; }
              GraphicalViewPlanElements = res;
            })

            if(this._graphicalView.BackgroundImage){
              this._graphicalView.BackgroundImage.ContentBase64 = (await this.getBase64FromUrl(this._graphicalView.BackgroundImage.Url)).split(',')[1];
            }

            delete this._graphicalView['PlanElements[]'];

            this.coreProxyService.GraphicalViewService.CreateGraphicalView(
              this._appService.getAccessToken(),
              this._appService.getFacilityID(),
              this._graphicalView,
              async res => {
                this._newGraphicalViewId = res.GraphicalViewID;
                this.planService.storeGraphicalViewPlanElements(GraphicalViewPlanElements, this._newGraphicalViewId).subscribe(
                  (success: CoreTypes.GraphicalViewPlanElement[]) =>{
                    this._graphicalView.PlanElements = this._graphicalView.PlanElements.concat(success);
                    this._graphicalView = JSON.parse(JSON.stringify(this._graphicalView));
                    this._pageStatus = 1;
                    this._description = '';
                    this.getData();
                    this._modalCloneView.close();
                    this._appService.stopLoading();
                  },
                  err =>{
                    this._errorMessage = err.Message;
                  }
                )
              },
              err => {
                this._errorMessage = err.Message;
                this._pageStatus = 2;
              }
            );
          }
        },
        (err) => {
          this._appService.showException(err);
        }
      );
    }
  }

  async getBase64FromUrl(url: string): Promise<any> {
    const data = await fetch(url);
    const blob = await data.blob();
    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.readAsDataURL(blob);
      reader.onloadend = function() {
        const base64data = reader.result;
        resolve(base64data);
      }
    });
  }
  
  goBack(link) {
    history.back();
  }
 
}
